import React from 'react'
import { Details, IconLine, Line, Stage as StageUI } from './../../style/styled'
import { CurrentDetails } from './CurrentDetails'
import { FieldValue } from './FieldValue'
import { displayTimeWithETAATA } from './function'
import { IconWithPopover } from './IconWithPopover'
import { PercentagePopOver, Span } from './styled'
import { TTansportModes } from './types'
import {
  MdNotListedLocation,
  ModeAir,
  ModeOcean,
  ModeRail,
  ModeRoad
} from '@fareye/utils'
interface IStage {
  name?: string
  city?: string
  style?: {
    stage?: React.CSSProperties
    name?: React.CSSProperties
    iconLine?: React.CSSProperties
    iconWrapper?: React.CSSProperties
  }
  details?: any
  rowData?: any
  eta?: string
  icon?: any
  line?: {
    color?: string
    width?: number | null
    style?: 'dotted' | 'solid'
    icon?: any
  }
  showPercentage?: any
  tripRunningStatus?: any
  transportationMode?: TTansportModes | null
  percTripCovered?: any
  showVehicle?: boolean
  locationNotFound?: boolean
  hideETA?: boolean
  noStops?: boolean
}

export function Stage(props: IStage) {
  const {
    name,
    style,
    icon,
    line,
    details,
    showPercentage,
    tripRunningStatus,
    transportationMode,
    percTripCovered,
    rowData,
    showVehicle,
    locationNotFound,
    hideETA,
    noStops = false
  } = props

  const [currentDetails, setCurrentDetails] = React.useState<boolean>(false)

  const iconSize = 20

  const statusStyle = {
    maxWidth: 120,
    justifyContent: 'center',
    ...(tripRunningStatus ? tripRunningStatus.style : {})
  }
  const statusDuration = tripRunningStatus
    ? `${tripRunningStatus.label} ${tripRunningStatus.labelStatus}`
    : ''
  let TptMode: any = undefined
  if (transportationMode === 'air') {
    TptMode = ModeAir
  } else if (transportationMode === 'ocean') {
    TptMode = ModeOcean
  } else if (transportationMode === 'road') {
    TptMode = ModeRoad
  } else if (transportationMode === 'rail') {
    TptMode = ModeRail
  }

  const nodeTimeLabel = details?.ata?.time
    ? displayTimeWithETAATA(details?.ata, 'ATA')
    : hideETA
    ? '\u00a0'
    : details?.eta?.time
    ? displayTimeWithETAATA(details?.eta, 'ETA')
    : '\u00a0'
  const isDash = !nodeTimeLabel || nodeTimeLabel === '-'
  return (
    <StageUI column style={style?.stage}>
      <Details column style={{ boxSizing: 'content-box' }}>
        {name ? (
          <Span
            style={{
              ...style?.name,
              ...{
                transform: 'translateX(calc(1ch - 50%))',
                width: 'max-content',
                maxWidth: '12em',
                position: 'relative',
                top: '9px',
                left: '8.5px',
                textAlign: 'center',
                alignitems: 'center'
              }
            }}
            variant="ellipsis"
          >
            {name}
          </Span>
        ) : (
          <Span variant="ellipsis">&nbsp;</Span>
        )}
      </Details>
      <IconLine style={style && style.iconLine}>
        {line ? (
          <Line
            borderColor={line.color}
            width={null}
            borderStyle={line.style}
            style={{ top: `${iconSize / 2}px`, position: 'absolute' }}
          />
        ) : null}
        <IconWithPopover
          popoverType="stop"
          icon={icon}
          details={details}
          hideETA={hideETA}
          styles={style}
        />
        {showVehicle &&
          TptMode &&
          locationNotFound &&
          Number(percTripCovered) !== 100 && (
            <IconWithPopover
              popoverType="currentDetails"
              currentDetails={rowData}
              hideETA={hideETA}
              styles={{
                iconWrapper: {
                  left: `calc(${50}% )`,
                  top: '-30px',
                  transform: 'translateX(-50%)',
                  position: 'absolute',
                  boxSizing: 'content-box'
                }
              }}
              icon={<img src={MdNotListedLocation} style={{ width: '16px' }} />}
            />
          )}
        {showVehicle && TptMode && Number(percTripCovered) !== 100 && (
          <IconWithPopover
            popoverType="currentDetails"
            currentDetails={rowData}
            hideETA={hideETA}
            styles={{
              iconWrapper: {
                left: `calc(${50}% )`,
                top: '-10px',
                transform: 'translateX(-50%)',
                position: 'absolute',
                boxSizing: 'content-box'
              }
            }}
            icon={
              <TptMode
                size={25}
                style={{ fill: '#1276D3' }}
                svgStyle={{ width: '30px', height: '30px' }}
              />
            }
          />
        )}
        {noStops &&
        TptMode &&
        locationNotFound &&
        Number(percTripCovered) !== 100 ? (
          <IconWithPopover
            popoverType="currentDetails"
            currentDetails={rowData}
            hideETA={hideETA}
            styles={{
              iconWrapper: {
                left: `calc(${line?.width}% )`,
                top: '-30px',
                transform: 'translateX(-50%)',
                position: 'absolute',
                boxSizing: 'content-box'
              }
            }}
            icon={<img src={MdNotListedLocation} style={{ width: '16px' }} />}
          />
        ) : null}
        {noStops && TptMode && Number(percTripCovered) !== 100 ? (
          <IconWithPopover
            popoverType="currentDetails"
            currentDetails={rowData}
            hideETA={hideETA}
            styles={{
              iconWrapper: {
                left: `calc(${line?.width}% )`,
                top: '-10px',
                transform: 'translateX(-50%)',
                position: 'absolute',
                boxSizing: 'content-box'
              }
            }}
            icon={
              <TptMode
                size={25}
                style={{ fill: '#1276D3' }}
                svgStyle={{ width: '30px', height: '30px' }}
              />
            }
          />
        ) : null}
        {showPercentage &&
        percTripCovered &&
        Number(percTripCovered) !== 100 ? (
          <PercentagePopOver leftMargin={line?.width}>
            <Span>{percTripCovered}%</Span>
          </PercentagePopOver>
        ) : null}
      </IconLine>
      <Details column disableTransform={true} style={{ gap: '0.25em' }}>
        <FieldValue
          style={{
            maxWidth: '140',
            position: 'relative',
            left: '-70px',
            textAlign: 'center'
          }}
          // valueStyle={
          //   !isDash
          //     ? {
          //         transform: 'translateX(-50%)'
          //       }
          //     : { display: 'none' }
          // }
          value={nodeTimeLabel}
        />
        <FieldValue
          valueStyle={statusStyle}
          value={statusDuration}
          style={{
            transform: 'translateX(calc(1ch - 50%))',
            width: 'max-content',
            maxWidth: '12em',
            position: 'relative',
            textAlign: 'center',
            alignitems: 'center'
          }}
        />
      </Details>
      {currentDetails ? (
        <CurrentDetails
          details={details}
          rowData={rowData}
          close={() => setCurrentDetails(false)}
        />
      ) : null}
    </StageUI>
  )
}
